module.exports = __webpack_public_path__ + "static/media/ob-university.ae6ad873.png";